import { Link, useLoaderData, useParams } from "react-router-dom";
import * as API from "../services/conspretratamiento";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getConspretratamientoByID(params.consultapretratamientoId);
}

export function ConspretratamientoItem(props) {
  const conspretratamiento = useLoaderData();
  const errorMessage = conspretratamiento?.message;

  const conspretResp = conspretratamiento.meta?.conspretResp;
  const metaFecha = conspretratamiento.meta?.metaFecha;
  const conspretMedio = conspretratamiento.meta?.conspretMedio;
  const conspretTipo = conspretratamiento.meta?.conspretTipo;
  const conspretObs = conspretratamiento.meta?.conspretObs;

  const conspretDate = new Date(conspretratamiento.date);
  const diffDate = (Math.abs(new Date() - conspretDate) / 36e5);

  let { tratamientoId } = useParams();

  return (
    <>
      <div id='content'>
        {conspretratamiento.length === 0 ? (
          <div>Cargando...</div>
        ) : (
        errorMessage? (
          <p>{errorMessage}</p>
        ) : (
          <form id='formUpdatelement'>
            <fieldset id='disabledContainer' disabled='disabled'>
              <div className='grid--2col'>
                <div className='field'>
                  <label htmlFor='conspretResp'>Responsable</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='conspretResp'
                      required
                      type='text'
                      readOnly
                      value={conspretResp}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='metaFecha'>Fecha visita</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='metaFecha'
                      required
                      type='date'
                      readOnly
                      value={metaFecha}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='conspretMedio'>Medio</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='conspretMedio'
                        required
                        name='conspretMedio'
                        value={conspretMedio}
                      >
                        <option disabled readOnly value=''>
                          -- Selecciona una opción --
                        </option>
                        <option readOnly value='presencial'>
                          Presencial
                        </option>
                        <option readOnly value='videoconferencia'>
                          Videoconferencia
                        </option>
                        <option readOnly value='telefonico'>
                          Telefónico
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='conspretTipo'>Tipo</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='conspretTipo'
                        required
                        name='conspretTipo'
                        value={conspretTipo}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='medica'>Médica</option>
                        <option value='psicologica'>Psicológica</option>
                        <option value='psiquiatrica'>Psiquiátrica</option>
                        <option value='ypsilon'>Ypsilon ambulatorio</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className='field'>
                <label htmlFor='conspretObs'>Observaciones</label>
                <div className='control'>
                  <textarea
                    className='textarea'
                    name='conspretObs'
                    id='conspretObs'
                    readOnly
                    value={conspretObs}
                  ></textarea>
                </div>
              </div>
            </fieldset>
          </form>
       ))}
      </div>
      {!errorMessage &&
      <div id='actions'>
      {((diffDate <= 72) && ((props.userRole.includes('psicologia-hospital') && conspretTipo === "psicologica") || (props.userRole.includes('psicologia') && conspretTipo === "psicologica") || (props.userRole.includes('medicina') && conspretTipo === "medica")) || (props.userRole.includes('administrador')))  &&
        <Link className='button is-link' to={`edit`}>
          Editar
        </Link>
      }
      {(props.userRole.includes('administrador') || props.userRole.includes('psicologia-hospital') || props.userRole.includes('psicologia') || props.userRole.includes('medicina')) && (
      <Link className="button is-link" to={`../${tratamientoId}/antecedentes/consulta-pre-tratamiento/new`}>Nuevo</Link>
      )}
      </div>
      }
    </>
  );
}